import React from 'react';

interface MoneyInputProps {
  value: number | undefined | null;
  onChange: (numericValue: number | undefined) => void;
  placeholder?: string;
  className?: string;
  min?: string;
  required?: boolean;
}

function formatIL(n: number): string {
  return new Intl.NumberFormat('he-IL').format(n);
}

export default function MoneyInput({
  value,
  onChange,
  placeholder = '',
  className = '',
  min,
  required,
}: MoneyInputProps) {
  const displayValue = value != null && value > 0 ? formatIL(value) : '';

  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    const raw = e.target.value.replace(/[^\d]/g, '');
    if (!raw) {
      onChange(undefined);
      return;
    }
    onChange(Number(raw));
  }

  return (
    <input
      type="text"
      inputMode="numeric"
      value={displayValue}
      onChange={handleChange}
      placeholder={placeholder}
      className={className}
      min={min}
      required={required}
    />
  );
}
